import React from 'react';
import Wetter from '../components/Wetter';
import './home.css'; // gleiche Styles wie bei Home verwenden

function WetterMurau() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="wetter-murau-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="wetter-murau-heading">WETTER</h1>
        </div>

        <Wetter ort="murau" />
      </div>
    </div>
  );
}

export default WetterMurau;
